import axios from 'axios';
import AuthService from './AuthService';

class MultiAcessoService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || 'https://portalrelacionamentoapi.dev-gam.com';
    }

    // Autentica um usuário do portal multi-acesso (login/senha) e já guarda
    // o token retornado como token ativo das próximas chamadas de API.
    async autenticar(login, senha) {
        try {
            const response = await axios.post(`${this.apiUrl}/multi-acesso/autenticar`, {
                login,
                senha,
            });

            if (response.data.status !== 'OK') {
                throw new Error(response.data.mensagem || 'Usuário ou senha inválidos.');
            }

            const conteudo = response.data.conteudo;
            AuthService.setPortalToken(conteudo.token);

            return conteudo;
        } catch (error) {
            const mensagem = error.response?.data?.mensagem || error.message || 'Erro ao autenticar.';
            throw new Error(mensagem);
        }
    }

    // Consome um token de acesso administrativo (link "acessar como", gerado por um sistema
    // interno GAM) — uso único, sem senha nenhuma envolvida. Não leva Authorization: o próprio
    // token na URL é a credencial, validado e já invalidado pelo backend nesta chamada.
    async validarAcessoAdministrativo(token) {
        try {
            const response = await axios.post(`${this.apiUrl}/multi-acesso/admin/validar-acesso/${token}`);

            if (response.data.status !== 'OK') {
                throw new Error(response.data.mensagem || 'Link de acesso inválido ou expirado.');
            }

            const conteudo = response.data.conteudo;
            AuthService.setPortalToken(conteudo.token);

            return conteudo;
        } catch (error) {
            const mensagem = error.response?.data?.mensagem || error.message || 'Link de acesso inválido ou expirado.';
            throw new Error(mensagem);
        }
    }

    // RN007: troca obrigatória de senha no primeiro acesso. Usa o token do portal já
    // guardado por AuthService (definido no login), não é preciso reenviar cdUsuario.
    async trocarSenhaPrimeiroAcesso(novaSenha) {
        try {
            const response = await axios.post(
                `${this.apiUrl}/multi-acesso/trocar-senha-primeiro-acesso`,
                { novaSenha },
                { headers: { Authorization: `Bearer ${AuthService.getActiveToken()}` } }
            );

            if (response.data.status !== 'OK') {
                throw new Error(response.data.mensagem || 'Não foi possível atualizar a senha.');
            }
        } catch (error) {
            const mensagem = error.response?.data?.mensagem || error.message || 'Erro ao atualizar a senha.';
            throw new Error(mensagem);
        }
    }

    // Log de acesso: avisa o backend que o usuário passou a visualizar este cliente —
    // acessoInicial=true na seleção logo após o login, false numa troca de cliente feita
    // depois, pelo dropdown do cabeçalho. É só um beacon de auditoria: não bloqueia a
    // navegação do usuário se falhar, por isso não propaga erro para quem chamou.
    async selecionarCliente(cdCliente, acessoInicial = false) {
        try {
            await axios.post(
                `${this.apiUrl}/multi-acesso/selecionar-cliente/${cdCliente}`,
                null,
                {
                    params: { acessoInicial },
                    headers: { Authorization: `Bearer ${AuthService.getActiveToken()}` },
                }
            );
        } catch (error) {
            console.error('Erro ao registrar log de acesso do cliente selecionado:', error);
        }
    }
}

export default new MultiAcessoService();
